<template>
  <div>
    <el-row :gutter="20">
      <el-col v-bind:class="mobileSelected" :sm="{ span: 6}">
        <list :listData="recipes" @select="handleSelectRecipeCategory"/>
      </el-col>
      <el-col :sm="{ span: 18}">
        <router-view :categoryId="selectedUseId"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import List from '@/components/List'
import { mapGetters } from 'vuex'

export default {
  name: 'Uses',
  props: ['useId'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['categories', 'uses']),
    mobileSelected() {
      const isSelected = !!this.selectedUseId
      return { 'hidden-xs-only': isSelected }
    },
    selectedUseId() {
      return this.$route.params.categoryId
    },
    recipes() {
      if (this.uses.length === 0) return []
      const recipeIds = this.uses
        .find(u => u.Id === this.useId)
        .SubUseIds.split(',')
      return this.categories.filter(u => {
        return recipeIds.includes(u.Id)
      })
    }
  },
  methods: {
    handleSelectRecipeCategory(item) {
      this.$router.push({ path: `/useCatagories/${this.useId}/${item.Id}` })
    },
    handleSelectUse(item) {
      this.selectedUse = item
      this.$router.push({ path: '/useCatagories/' + item.Id })
    }
  },
  components: {
    List
  }
}
</script>
<style scoped>
